(function () {
  'use strict';
  function init(root) {
    if (!root || root.__ft) return;
    root.__ft = true;
    var top = root.querySelector('[data-ft-top]');
    if (top) {
      top.hidden = false;
      top.addEventListener('click', function () {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    if (!('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { root.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.2 });
    io.observe(root);
  }
  function boot() { var r = document.querySelectorAll('[data-ft]'); for (var i = 0; i < r.length; i++) init(r[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-ft]'); if (r) init(r); });
})();